import { dew as _SecretsResponseDew } from "./SecretsResponse";
import { dew as _WriteSecretDew } from "./WriteSecret";
import { dew as _SecretDew } from "./Secret";
import { dew as _SecretNameDew } from "./SecretName";
import { dew as _SecretValueDew } from "./SecretValue";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function () {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });
  var __exportStar = exports && exports.__exportStar || function (m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  __exportStar(_SecretsResponseDew(), exports);
  __exportStar(_WriteSecretDew(), exports);
  __exportStar(_SecretDew(), exports);
  __exportStar(_SecretNameDew(), exports);
  __exportStar(_SecretValueDew(), exports);
  return exports;
}